import clsx from 'clsx';
import type { ScrapingQualityReport } from '@/types/echo_creation';

interface ScrapingReportProps {
  report: ScrapingQualityReport;
}

function PlatformBadge({ name, variant }: { name: string; variant: 'success' | 'failure' }) {
  const isSuccess = variant === 'success';
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full px-3 py-1 font-sans text-12',
        isSuccess ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-600'
      )}
    >
      <span
        className={clsx('size-[6px] rounded-full', isSuccess ? 'bg-green-500' : 'bg-red-400')}
      />
      {name.charAt(0).toUpperCase() + name.slice(1)}
    </span>
  );
}

export function ScrapingReport({ report }: ScrapingReportProps) {
  const sourceMessage =
    report.total_sources >= 3
      ? `Great! Found ${report.total_sources} sources — enough for a detailed echo`
      : report.total_sources >= 1
        ? `Found ${report.total_sources} source${report.total_sources > 1 ? 's' : ''} — your echo may be less detailed`
        : 'No data found — using personality survey only';

  return (
    <div className='mt-4 rounded-10 border border-gray-100 bg-gray-50 p-4'>
      <p className='mb-2 font-sans text-14 font-medium text-dark-100'>{sourceMessage}</p>
      {report.platforms_attempted.length > 0 && (
        <div className='flex flex-wrap gap-2'>
          {report.platforms_succeeded.map((platform) => (
            <PlatformBadge key={platform} name={platform} variant='success' />
          ))}
          {report.platforms_failed.map((platform) => (
            <PlatformBadge key={platform} name={platform} variant='failure' />
          ))}
        </div>
      )}
    </div>
  );
}
